/**
 * AP-6 — CanFilterRangeWindow (FM-WIN-16), Titel "Filter Range". Wirkt
 * ZUSÄTZLICH zum Maskenfilter, nicht anstelle (CONTRACTS.md §4 Schritt 3+4).
 * Anders als die Maske hat Range keinen Fehlerpfad: `strtoul` liefert bei
 * ungültiger Eingabe 0 (CanFilterRangeWindow::GetRangeMin/Max, 1:1 übernommen).
 */

import { createButton, createInput, createLabel } from '../../ui/controls';
import { createFloatingPanel, type FloatingPanel } from './FloatingPanel';

export interface FilterRangeDialogOptions {
  onApply: (min: number, max: number) => void;
  onClear: () => void;
}

export interface FilterRangeDialogHandle {
  panel: FloatingPanel;
}

export function createFilterRangeDialog(options: FilterRangeDialogOptions): FilterRangeDialogHandle {
  const panel = createFloatingPanel('Filter Range');

  const minInput = createInput();
  minInput.value = '00000000';
  const maxInput = createInput();
  maxInput.value = '1FFFFFFF';

  const minRow = document.createElement('div');
  minRow.className = 'cm-panel-window__row';
  minRow.append(createLabel('Min ID (hex):'), minInput);

  const maxRow = document.createElement('div');
  maxRow.className = 'cm-panel-window__row';
  maxRow.append(createLabel('Max ID (hex):'), maxInput);

  const buttons = document.createElement('div');
  buttons.className = 'cm-panel-window__buttons';
  buttons.append(
    createButton('Apply Range Filter', {
      accent: true,
      onClick: () => {
        const a = parseHexOrZero(minInput.value);
        const b = parseHexOrZero(maxInput.value);
        options.onApply(Math.min(a, b), Math.max(a, b));
      },
    }),
    createButton('Clear Range Filter', { onClick: () => options.onClear() }),
  );

  panel.body.append(minRow, maxRow, buttons);
  return { panel };
}

/** Gegenstück zu `std::strtoul(buf, nullptr, 16)`: ungültige Eingabe -> 0, kein Fehler. */
function parseHexOrZero(text: string): number {
  const trimmed = text.trim();
  const match = /^[0-9a-fA-F]+/.exec(trimmed);
  if (match === null) return 0;
  const value = Number.parseInt(match[0], 16);
  return Number.isFinite(value) ? value >>> 0 : 0;
}
